import * as React from 'react';

import Page from 'components/page/Page';

import ListsView from '../components/lists-view/ListsView';

import { t } from 'utils/language';

import type { LocationWindow, ParamsLists } from 'types';

type Props = {
  params: ParamsLists,
  location: LocationWindow
};

class ListsViewPage extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { params, location } = this.props;

    return (
      <Page
        documentTitle={t('lists.browser_title')}
      >
        <ListsView
          params={params}
          location={location}
        />
      </Page>
    );
  }
}

export default ListsViewPage;
